// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3_JGH","content":"styles_content__3bhkz","checkbox":"styles_checkbox__14bBT","checkboxLabel":"styles_checkboxLabel__2m81p"};